import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Sidebar = ({ }) => {
  const [activeObject, setActiveObject] = useState({
    home: "mm-active",
    reportdata: "",
    alerts: "",
    reportdataview: "",
  });
  const setActiveTab = () => {
    let activeStateHolder = {
      home: "",
      reportdata: "",
      alerts: "",
      reportdataview: "",
      // facilitymgmnt:""
    }
    let currentPath = window.location.pathname.split('/').pop()
    activeStateHolder[currentPath] = "mm-active"
    setActiveObject(activeStateHolder)
  }
  return (<>
    <div className="scrollbar-sidebar">
      <div className="app-sidebar__inner">
        <ul className="vertical-nav-menu">
          <li className="app-sidebar__heading" onClick={() => setActiveTab()}>
            <Link
              to="home"
              className={`nav-link ${activeObject.home}`}
            >
              Dashboard
            </Link>
          </li>
          <li className="app-sidebar__heading" onClick={() => setActiveTab()}>
            <Link
              to="reportdata"
              className={`nav-link ${activeObject.reportdata}`}
            >SR Monitoring
            </Link>
          </li>
          <li className="app-sidebar__heading" onClick={() => setActiveTab()}>
            <Link
              to="reportdataview"
              className={`nav-link ${activeObject.reportdataview}`}
            >Quaterly Report
            </Link>
          </li>
          <li className="app-sidebar__heading"  onClick={() => setActiveTab()}>
            <Link
              to="alerts"
              className={`nav-link ${activeObject.alerts}`}
            >Alerts
            </Link>
          </li>
          <li className="app-sidebar__heading" onClick={() => setActiveTab()} >
            <Link
              to="historicreports"
              className={`nav-link`}
            >
              Historic Reports
            </Link>
          </li>
          {/* <li className="app-sidebar__heading" onClick={() => setActiveTab()} >
            <Link
              to="facilitymgmnt"
              className={`nav-link`}
            >
              Facility Management
            </Link>
          </li> */}
          <li className="app-sidebar__heading" onClick={() => setActiveTab()} >
            <Link
              to="home"
              className={`nav-link `}
            >
              Advance Analytics
            </Link>
          </li>
        </ul>
      </div>
    </div>
  </>)
}
export default Sidebar